import * as ambassadorWixEcomV1BackInStockNotificationRequest from './ecom-v1-back-in-stock-notification-request-back-in-stock-notifications.http.js';
import * as ambassadorWixEcomV1BackInStockNotificationRequestTypes from './ecom-v1-back-in-stock-notification-request-back-in-stock-notifications.types.js';
import * as ambassadorWixEcomV1BackInStockNotificationRequestUniversalTypes from './ecom-v1-back-in-stock-notification-request-back-in-stock-notifications.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createBackInStockNotificationRequest(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1BackInStockNotificationRequestUniversalTypes.CreateBackInStockNotificationRequestRequest,
  ambassadorWixEcomV1BackInStockNotificationRequestTypes.CreateBackInStockNotificationRequestRequest,
  ambassadorWixEcomV1BackInStockNotificationRequestUniversalTypes.CreateBackInStockNotificationRequestResponse,
  ambassadorWixEcomV1BackInStockNotificationRequestTypes.CreateBackInStockNotificationRequestResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1BackInStockNotificationRequest.createBackInStockNotificationRequest(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/back-in-stock-notification-requests',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getBackInStockNotificationRequest(): __PublicMethodMetaInfo<
  'GET',
  { id: string },
  ambassadorWixEcomV1BackInStockNotificationRequestUniversalTypes.GetBackInStockNotificationRequestRequest,
  ambassadorWixEcomV1BackInStockNotificationRequestTypes.GetBackInStockNotificationRequestRequest,
  ambassadorWixEcomV1BackInStockNotificationRequestUniversalTypes.GetBackInStockNotificationRequestResponse,
  ambassadorWixEcomV1BackInStockNotificationRequestTypes.GetBackInStockNotificationRequestResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1BackInStockNotificationRequest.getBackInStockNotificationRequest(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/back-in-stock-notification-requests/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteBackInStockNotificationRequest(): __PublicMethodMetaInfo<
  'DELETE',
  { id: string },
  ambassadorWixEcomV1BackInStockNotificationRequestUniversalTypes.DeleteBackInStockNotificationRequestRequest,
  ambassadorWixEcomV1BackInStockNotificationRequestTypes.DeleteBackInStockNotificationRequestRequest,
  ambassadorWixEcomV1BackInStockNotificationRequestUniversalTypes.DeleteBackInStockNotificationRequestResponse,
  ambassadorWixEcomV1BackInStockNotificationRequestTypes.DeleteBackInStockNotificationRequestResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1BackInStockNotificationRequest.deleteBackInStockNotificationRequest(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/back-in-stock-notification-requests/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function markAsNotificationSent(): __PublicMethodMetaInfo<
  'PUT',
  { id: string },
  ambassadorWixEcomV1BackInStockNotificationRequestUniversalTypes.MarkAsNotificationSentRequest,
  ambassadorWixEcomV1BackInStockNotificationRequestTypes.MarkAsNotificationSentRequest,
  ambassadorWixEcomV1BackInStockNotificationRequestUniversalTypes.MarkAsNotificationSentResponse,
  ambassadorWixEcomV1BackInStockNotificationRequestTypes.MarkAsNotificationSentResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1BackInStockNotificationRequest.markAsNotificationSent(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PUT',
    path: '/v1/back-in-stock-notification-requests/{id}/mark-as-notification-sent',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryBackInStockNotificationRequests(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixEcomV1BackInStockNotificationRequestUniversalTypes.QueryBackInStockNotificationRequestsRequest,
  ambassadorWixEcomV1BackInStockNotificationRequestTypes.QueryBackInStockNotificationRequestsRequest,
  ambassadorWixEcomV1BackInStockNotificationRequestUniversalTypes.QueryBackInStockNotificationRequestsResponse,
  ambassadorWixEcomV1BackInStockNotificationRequestTypes.QueryBackInStockNotificationRequestsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1BackInStockNotificationRequest.queryBackInStockNotificationRequests(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/back-in-stock-notification-requests',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getBackInStockNotificationRequestsCountByCatalogReferences(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixEcomV1BackInStockNotificationRequestUniversalTypes.GetBackInStockNotificationRequestsCountByCatalogReferencesRequest,
  ambassadorWixEcomV1BackInStockNotificationRequestTypes.GetBackInStockNotificationRequestsCountByCatalogReferencesRequest,
  ambassadorWixEcomV1BackInStockNotificationRequestUniversalTypes.GetBackInStockNotificationRequestsCountByCatalogReferencesResponse,
  ambassadorWixEcomV1BackInStockNotificationRequestTypes.GetBackInStockNotificationRequestsCountByCatalogReferencesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1BackInStockNotificationRequest.getBackInStockNotificationRequestsCountByCatalogReferences(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/back-in-stock-notification-requests/count-by-catalog-reference',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function reportItemsBackInStock(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1BackInStockNotificationRequestUniversalTypes.ReportItemsBackInStockRequest,
  ambassadorWixEcomV1BackInStockNotificationRequestTypes.ReportItemsBackInStockRequest,
  ambassadorWixEcomV1BackInStockNotificationRequestUniversalTypes.ReportItemsBackInStockResponse,
  ambassadorWixEcomV1BackInStockNotificationRequestTypes.ReportItemsBackInStockResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1BackInStockNotificationRequest.reportItemsBackInStock(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/back-in-stock-notification-requests/report-items-back-in-stock',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  BackInStockNotificationRequest as BackInStockNotificationRequestOriginal,
  CatalogReference as CatalogReferenceOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  InvalidateCache as InvalidateCacheOriginal,
  InvalidateCacheGetByOneOf as InvalidateCacheGetByOneOfOriginal,
  App as AppOriginal,
  Page as PageOriginal,
  URI as URIOriginal,
  File as FileOriginal,
  CustomTag as CustomTagOriginal,
  Pages as PagesOriginal,
  URIs as URIsOriginal,
  CreateBackInStockNotificationRequestRequest as CreateBackInStockNotificationRequestRequestOriginal,
  BackInStockItemDetails as BackInStockItemDetailsOriginal,
  Image as ImageOriginal,
  FocalPoint as FocalPointOriginal,
  CreateBackInStockNotificationRequestResponse as CreateBackInStockNotificationRequestResponseOriginal,
  GetBackInStockNotificationRequestRequest as GetBackInStockNotificationRequestRequestOriginal,
  GetBackInStockNotificationRequestResponse as GetBackInStockNotificationRequestResponseOriginal,
  DeleteBackInStockNotificationRequestRequest as DeleteBackInStockNotificationRequestRequestOriginal,
  DeleteBackInStockNotificationRequestResponse as DeleteBackInStockNotificationRequestResponseOriginal,
  MarkAsNotificationSentRequest as MarkAsNotificationSentRequestOriginal,
  MarkAsNotificationSentResponse as MarkAsNotificationSentResponseOriginal,
  QueryBackInStockNotificationRequestsRequest as QueryBackInStockNotificationRequestsRequestOriginal,
  PlatformQuery as PlatformQueryOriginal,
  PlatformQueryPagingMethodOneOf as PlatformQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  PlatformPaging as PlatformPagingOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryBackInStockNotificationRequestsResponse as QueryBackInStockNotificationRequestsResponseOriginal,
  PlatformPagingMetadata as PlatformPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  GetBackInStockNotificationRequestsCountByCatalogReferencesRequest as GetBackInStockNotificationRequestsCountByCatalogReferencesRequestOriginal,
  GetBackInStockNotificationRequestsCountByCatalogReferencesResponse as GetBackInStockNotificationRequestsCountByCatalogReferencesResponseOriginal,
  BackInStockNotificationRequestsCount as BackInStockNotificationRequestsCountOriginal,
  ReportItemsBackInStockRequest as ReportItemsBackInStockRequestOriginal,
  ReportItemsBackInStockResponse as ReportItemsBackInStockResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  CreateBackInStockNotificationRequestApplicationErrors as CreateBackInStockNotificationRequestApplicationErrorsOriginal,
  MarkAsNotificationSentApplicationErrors as MarkAsNotificationSentApplicationErrorsOriginal,
  ReportItemsBackInStockApplicationErrors as ReportItemsBackInStockApplicationErrorsOriginal,
} from './ecom-v1-back-in-stock-notification-request-back-in-stock-notifications.types.js';
